import { useEffect, useRef } from "react";

// Scrolling / swiping past the end of a paged list flips to the next page; past the top flips back.
// A flip only happens when the gesture starts with that edge already in view, so normal scrolling is untouched.
export function useScrollPaging(ref, page, pages, setPage) {
  const s = useRef({ lock: 0, acc: 0, last: 0, atEdge: false, y: null, startEdges: null });
  s.current.page = page;
  s.current.pages = pages;

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const st = s.current;
    const edges = () => {
      const r = el.getBoundingClientRect();
      return { end: r.bottom <= window.innerHeight + 8, top: r.top >= 56 };
    };
    const canFlip = (dir, e) => (dir > 0 ? e.end && st.page < st.pages : e.top && st.page > 1);
    const flip = (dir) => {
      if (Date.now() < st.lock) return;
      st.lock = Date.now() + 800;
      st.acc = 0;
      setPage(st.page + dir);
      requestAnimationFrame(() => window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 96, behavior: "smooth" }));
    };
    const onWheel = (ev) => {
      const dir = ev.deltaY > 0 ? 1 : -1;
      const now = Date.now();
      if (now - st.last > 250) { st.atEdge = canFlip(dir, edges()); st.acc = 0; }
      st.last = now;
      if (!st.atEdge || !canFlip(dir, edges())) return;
      ev.preventDefault();
      st.acc += Math.abs(ev.deltaY);
      if (st.acc > 60) { st.atEdge = false; flip(dir); }
    };
    const onStart = (ev) => { st.y = ev.touches[0].clientY; st.startEdges = edges(); };
    const onEnd = (ev) => {
      if (st.y == null) return;
      const dy = st.y - ev.changedTouches[0].clientY;
      st.y = null;
      if (dy > 60 && canFlip(1, st.startEdges)) flip(1);
      else if (dy < -60 && canFlip(-1, st.startEdges)) flip(-1);
    };
    el.addEventListener("wheel", onWheel, { passive: false });
    el.addEventListener("touchstart", onStart, { passive: true });
    el.addEventListener("touchend", onEnd, { passive: true });
    return () => {
      el.removeEventListener("wheel", onWheel);
      el.removeEventListener("touchstart", onStart);
      el.removeEventListener("touchend", onEnd);
    };
  }, [ref, setPage]);
}
